import React, { ReactElement } from "react"
import { Box, HStack } from "@chakra-ui/react"
import MonitorIcon from "components/elements/MonitorIcon"
import SmartphoneIcon from "components/elements/SmartphoneIcon"

export type PreviewDevice = "desktop" | "mobile"

const DEVICES: { value: PreviewDevice, label: string, icon: ReactElement }[] = [
  { value: "desktop", label: "Desktop", icon: <MonitorIcon boxSize={4} /> },
  { value: "mobile", label: "Mobile", icon: <SmartphoneIcon boxSize={4} /> },
]

type Props = {
  value: PreviewDevice
  onChange: (device: PreviewDevice) => void
}

const DeviceToggle = ({ value, onChange }: Props) => (
  <HStack
    role="group"
    aria-label="Preview device"
    spacing="2px"
    h={8}
    p="2px"
    borderWidth={1}
    borderColor="gray.200"
    borderRadius="full"
  >
    {DEVICES.map(({ value: device, label, icon }) => {
      const selected = device === value

      return (
        <Box
          key={device}
          as="button"
          type="button"
          display="flex"
          alignItems="center"
          justifyContent="center"
          h="26px"
          w="34px"
          borderRadius="full"
          title={label}
          aria-label={label}
          aria-pressed={selected}
          color={selected ? "gray.900" : "gray.500"}
          bg={selected ? "gray.100" : "transparent"}
          _hover={{ bg: "gray.100", color: "gray.900" }}
          onClick={() => onChange(device)}
        >
          {icon}
        </Box>
      )
    })}
  </HStack>
)

export default DeviceToggle
